
import '@/assets/scss/index.scss'
import { pdMixin } from '@/mixin/pd/pdMixin'

export default {
  components: {
  },
  mixins: [pdMixin],
  props: {
    cpnInfo: { // 쿠폰 정보
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      visible: false,
      myPdDwldPsbCpnList: []
    }
  },
  watch: {
    visible (flag) {
      if (flag) {
        this.myPdDwldPsbCpnList = this.cpnInfo.data
      } else {
        // 초기화
        this.myPdDwldPsbCpnList = []
      }
    }
  },
  mounted () {
  },
  methods: {
    // 팝업 닫기
    close () {
      this.visible = false
    },

    // 쿠폰 다운로드드
    dwldCpn (cpnNo) {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }
      this.$AxiosBuilder
        .data({ cpnNo })
        .build()
        .post('/ev/evf/insCpnDwld')
        .then((res) => {
          // 쿠폰이 발급되었습니다. this.$t('DS.DOWNLOAD_COUPON_SUCCESS')
          console.log(res)
          this.openToast(res.data.message)
          this.selPdDwldPsbCpnList()
          // if (this.isNotEmpty(res.data.data)) {
          //   res.data.data.forEach((item) => {
          //     item.edDtm = dayjs(item.edDtm).format('YYYY.MM.DD')
          //   })
          //   const dwldCpnList = JSON.parse(JSON.stringify(res.data.data))
          //   this.dwldCpnList = dwldCpnList
          // }
        }).catch((e) => {
          console.log('LayerCpnDown dwldCpn error : ', e)
        })
    }
  }
}
